<template>
  <a-modal
    :title="`${date} 访问来源地理位置分布`"
    :visible="visible"
    :footer="null"
  >
    <a-row style="min-height: 700px">
      <a-col :span="12" style="height: 450px">
        <h3 class="chart-title">
          {{`${mapName ? mapName + '各市/州' : '全国各省'}访问来源分布`}}
        </h3>

        <a-empty v-if="!mapAllDatas.length && !loading" style="padding-top: 100px" />
        <MapChart
          v-else
          :height="450"
          :padding="[60, 120, 60, 20]"
          :mapCode="mapCode"
          :datas="mapAllDatas"
          :loading="loading"
          @dblclick="requestSourceMapClicked"
        />
      </a-col>
      <a-col :span="12" style="height: 450px">
        <h3 class="chart-title">
          {{`${mapName ? mapName + '各市/州' : '全国各省'}解码错误率分布`}}
        </h3>

        <a-empty v-if="!mapErrDatas.length && !loading" style="padding-top: 100px" />
        <MapChart
          v-else
          :height="450"
          :padding="[60, 120, 60, 20]"
          :mapCode="mapCode"
          :datas="mapErrDatas"
          :tooltipConfig="['district*value', this.mapErrToolTipFun]"
          :geoScaleConfig="[{ dataKey: 'value', alias: '错误率' }]"
          :geoColorsStr="mapErrColorStr"
          :loading="loading"
          @dblclick="requestSourceMapClicked"
        />
      </a-col>
      <a-col :span="24" style="height: 250px;position: relative;">
        <h3 class="chart-title">
          {{`${mapName ? mapName + '各市/州' : '全国各省'}访问来源`}}
        </h3>
        <div v-if="loading" class="spin-loading"><a-spin tip="加载中..." /></div>
        <template v-else>
          <a-empty v-if="!barDatas.length" style="padding-top: 50px" />
          <v-chart
            v-else
            :forceFit="true" :height="250" :padding="[50, 60, 50, 80] "
            :data="barDatas"
            :scale="[{ dataKey: 'value', alias: '访问次数' }]"
          >
            <v-tooltip />
            <v-axis dataKey="district" :label="{ textStyle: { fill: '#aaa' } }" />
            <v-axis dataKey="value" :label="{ textStyle: { fill: '#aaa' } }" />
            <v-bar
              position="district*value" :color="barColor"
              :adjust="[{ type: 'dodge', marginRatio: 1 / 32 }]"
              :tooltip="['name*value*rate', this.barTooltipFun]"
            />
          </v-chart>
        </template>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { keepTwoDecimalFull } from '@/utils/utils'

import MapChart from '@/components/DashboardCharts/MapChart'

export default {
  name: 'RDMapChart',
  components: { MapChart },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    date: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    },
    dateMode: {
      type: String,
      default: 'day'
    },

    datas: {
      type: Array,
      default: () => []
    },

    mapColorStr: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      mapName: '',
      mapCode: 100000,

      mapAllDatas: [],
      mapErrDatas: [],
      // mapErrColorStr: '#F9EBD3-#E5A189-#D06255-#B63836-#742426-#460E10',
      mapErrColorStr: '#FFEFDB-#FFD39B-#D06255-#B63836-#742426-#460E10',
      barLabel: ['value', { textStyle: { fill: '#aaa' } }],
      barColor: ['name', ['#1890ff', '#D06255']],
      barDatas: [],

      loading: false
    }
  },
  watch: {
    visible: function(visible) {
      if (visible && this.datas.length) {
        this.barDatas = this.datas
        this.mapAllDatas = this.datas.filter(d => d.name === '总请求量')
        this.mapErrDatas = this.datas.filter(d => d.name === '解码错误').map(e => {
          return {
            ...e,
            name: '解码错误率',
            value: e.rate
          }
        })
      }
    }
  },
  methods: {
    // moment,
    //
    // // 请求的 IP 归属地统计图
    // async getRequestSource(province) {
    //   try {
    //     this.loading = true
    //
    //     const start = moment(this.date).startOf(this.dateMode).format('YYYY-MM-DD HH:mm:ss')
    //     const end = moment(this.date).endOf(this.dateMode).format('YYYY-MM-DD HH:mm:ss')
    //
    //     let { collection } = await GetRequestSource({ province, start, end })
    //     collection.sort((prev, next) => next.amount - prev.amount)
    //
    //     // 生成统计数据
    //     const datas = []
    //     const mapAllDatas = []
    //     const mapErrDatas = []
    //     collection.map(item => {
    //       const { amount, city, province, failAmount } = item
    //       const district = city || province || '其他'
    //
    //       const all = { name: '总请求量', district, value: amount }
    //       const err = { name: '解码错误', district, value: failAmount || 0, rate: keepTwoDecimalFull(((failAmount || 0) / amount) * 100) }
    //       datas.push(all, err)
    //       mapAllDatas.push(all)
    //       mapErrDatas.push({
    //         ...err,
    //         name: '解码错误率',
    //         value: err.rate
    //       })
    //     })
    //
    //     this.barDatas = datas
    //     this.mapAllDatas = mapAllDatas
    //     this.mapErrDatas = mapErrDatas
    //   } catch (error) {}
    //   this.loading = false
    // },
    // async requestSourceMapClicked(data) {
    //   try {
    //     const { mapName, mapCode } = data
    //     this.mapName = mapName
    //     this.mapCode = mapCode
    //     this.getRequestSource(this.mapName)
    //   } catch (error) {}
    // },
    //
    // handlerCloseModal() {
    //   this.mapName = ''
    //   this.mapCode = 100000
    //   this.mapAllDatas = []
    //   this.mapErrDatas = []
    //   this.barDatas = []
    //   this.$emit('hideModal')
    // },
    //
    // mapErrToolTipFun(name, value) {
    //   return { name, value: `${value}%` }
    // },
    // barTooltipFun(name, value, rate) {
    //   value = `${value} 次`
    //   if (rate) value = `${value} (${rate}%) 次`
    //   return { name, value }
    // }
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 1200px !important;
    top: 60px;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select :none;
    user-select: none
  }
  .chart-title {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0;
  }
  .spin-loading{
    background: rgba(255, 255, 255, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
